import * as React from 'react';

interface LpnContentPaginationButtonsProps {
  pageSize: number;
  currentPage: number;
  lpnCount: number;
  setCurrentPage: (pageNumber: number) => void;
}

const LpnContentPaginationButtons: React.FC<LpnContentPaginationButtonsProps> = (props) => {
  const pageBack = () => {
    if (props.currentPage > 1) {
      props.setCurrentPage(props.currentPage - 1);
    }
  };

  const pageForward = () => {
    const pageSize = props.pageSize;
    const endIndexThisPage = (props.currentPage - 1) * pageSize + pageSize;
    if (endIndexThisPage < props.lpnCount) {
      props.setCurrentPage(props.currentPage + 1);
    }
  };

  const lpnsCountDisplay = () => {
    const pageSize = props.pageSize;
    const totalRecords = props.lpnCount;
    let startIndex;

    if (props.lpnCount > 0) {
      startIndex = (props.currentPage - 1) * pageSize + 1;
    } else {
      startIndex = 0;
    }
    const endIndex = Math.min((props.currentPage - 1) * pageSize + pageSize, totalRecords);
    return (
      <span>
        <strong>
          {startIndex}-{endIndex}
        </strong>{' '}
        of {totalRecords}
      </span>
    );
  };

  return (
    <div className="lpns-index-bubble-container">
      <a
        className="lpns-page-back"
        onClick={() => {
          pageBack();
        }}
      >
        <i className="fa fa-angle-left"></i>
      </a>
      <span className="lpns-page-counter">{lpnsCountDisplay()}</span>
      <a
        className="lpns-page-forward"
        onClick={() => {
          pageForward();
        }}
      >
        <i className="fa fa-angle-right"></i>
      </a>
    </div>
  );
};

export default LpnContentPaginationButtons;
